<nav
  id="mainNav"
  class="navbar navbar-expand-xl navbar-light bg-light position-fixed top-0 start-0 w-100 shadow nav-elev nav-large"
  style="z-index:1050;"
  (click)="onNavClick($event)"
>
  <div class="container-fluid d-flex align-items-center">

    <!-- LOGO -->
    <a
      class="navbar-brand l-logo"
      routerLink="/"
      href="/"
      aria-label="Vai alla Home"
      (click)="closeNavbar()"
    >
      <img
        src="../../../assets/logo-sami.png"
        alt="SAMI Pulizie - Impresa di pulizie a Pescara"
        class="h-auto logo-img"
        width="155"
        height="48"
        loading="eager"
        decoding="async"
        fetchpriority="high"
      />
    </a>

    <!-- HAMBURGER -->
    <button
      class="navbar-toggler ms-auto"
      type="button"
      [attr.aria-expanded]="isMenuOpen"
      aria-controls="navbarSupportedContent"
      aria-label="Apri menu"
      (click)="toggleMenu()"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- MENU -->
    <div
      id="navbarSupportedContent"
      class="collapse navbar-collapse justify-content-between"
      [class.show]="isMenuOpen"
    >
      <!-- LEFT MENU -->
      <ul class="navbar-nav gap-3 mb-2 mb-xl-0">

        <!-- SEDE GIULIANOVA -->
        <li class="nav-item">
          <a class="nav-link" href="/impresa-pulizie-giulianova-teramo" routerLink="/impresa-pulizie-giulianova-teramo" (click)="closeNavbar()">
            Sede Giulianova
          </a>
        </li>

        <!-- SERVIZI -->
        <li class="nav-item dropdown" [class.show]="openDropdown === 'servizi'">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            [attr.aria-expanded]="openDropdown === 'servizi'"
            (click)="toggleDropdown('servizi', $event)"
          >
            Servizi
          </a>

          <ul class="dropdown-menu" [class.show]="openDropdown === 'servizi'">

            <li>
              <a class="dropdown-item" href="/sanificazioni" routerLink="/sanificazioni" (click)="closeNavbar()">
                Sanificazioni
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="/uffici" routerLink="/uffici" (click)="closeNavbar()">
                Uffici privati/pubblici
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="/condomini" routerLink="/condomini" (click)="closeNavbar()">
                Pulizie Condomini
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="/palestra" routerLink="/palestra" (click)="closeNavbar()">
                Pulizie Palestre
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="/straordinaria" routerLink="/straordinaria" (click)="closeNavbar()">
                Pulizie Straordinarie
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="/domestica" routerLink="/domestica" (click)="closeNavbar()">
                Pulizie Domestiche
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="/cucine-industriali" routerLink="/cucine-industriali" (click)="closeNavbar()">
                Pulizie Cucine Industriali
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="/laboratori-alimentari" routerLink="/laboratori-alimentari" (click)="closeNavbar()">
                Pulizie Laboratori
              </a>
            </li>
          </ul>
        </li>

        <!-- CONTATTI -->
        <li class="nav-item dropdown" [class.show]="openDropdown === 'contatti'">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            [attr.aria-expanded]="openDropdown === 'contatti'"
            (click)="toggleDropdown('contatti', $event)"
          >
            Contatti
          </a>

          <ul class="dropdown-menu" [class.show]="openDropdown === 'contatti'">
            <li>
              <a class="dropdown-item" href="tel:08554360" (click)="closeNavbar()">
                Call Center Pescara · 085 54360
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="tel:0859155805" (click)="closeNavbar()">
                Call Center Giulianova · 085 9155805
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="mailto:info@samipulizie.it" (click)="closeNavbar()">
                Email Pescara · info&#64;samipulizie.it
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="mailto:commerciale.te@samipulizie.it" (click)="closeNavbar()">
                Email Giulianova · commerciale.te&#64;samipulizie.it
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.google.com/maps/place/Via+Tirino,+145,+Pescara"
                (click)="closeNavbar()"
              >
                Sede Pescara · Via Tirino 145
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.google.com/maps/search/?api=1&query=42.7533741%2C13.9669969"
                (click)="closeNavbar()"
              >
                Sede Giulianova · Corso Nazario Sauro 118
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="/collaboratori" routerLink="/collaboratori" (click)="closeNavbar()">
            I nostri collaboratori
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="/lavora-con-noi" routerLink="/lavora-con-noi" (click)="closeNavbar()">
            Lavora con noi
          </a>
        </li>

        <!-- BLOG -->
        <li class="nav-item">
          <a class="nav-link" href="/blog" routerLink="/blog" (click)="closeNavbar()">Blog</a>
        </li>
      </ul>

      <!-- RIGHT BUTTONS -->
      <ul class="navbar-nav align-items-center gap-3">
        <li class="nav-item">
          <a class="btn btn-rosa px-3 py-2" href="/preventivo" routerLink="/preventivo" (click)="closeNavbar()">
            Richiedi il tuo preventivo
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
